import {
    TOGGLE_CARD,
    TOGGLE_CALENDAR,
    TOGGLE_MODAL,
    TOGGLE_SUCCESS_MESSAGE,
    TOGGLE_ROLE_POPOUT,
} from '../actions/ViewController';

export default function(state = {}, action) {
    const newState = JSON.parse(JSON.stringify(state));

    // eslint-disable-next-line default-case
    switch (action.type) {
        case TOGGLE_CARD:
            newState.rolePopout = action.payload;
            return newState;
        case TOGGLE_CALENDAR:
            newState.calendar = action.payload;
            return newState;
        case TOGGLE_MODAL:
            const { modal } = action.payload;
            newState.modals[modal] = action.payload.type;
            return newState;
        case TOGGLE_SUCCESS_MESSAGE:
            newState.success_message = action.payload;
            return newState;
        case TOGGLE_ROLE_POPOUT:
            const { popOut } = action.payload;
            newState.rolePopout[popOut] = action.payload.type;
            return newState;
    }
    return state;
}
